export const thursdayAbbreviatedLowercase = "ura";
export default {thursdayAbbreviatedLowercase};